// extracted by mini-css-extract-plugin
export default {"back-button":"AJnI8u","backButton":"AJnI8u"};